import { render, staticRenderFns } from "./producer_tastings_tab.vue?vue&type=template&id=6e6842ad&scoped=true"
import script from "./producer_tastings_tab.vue?vue&type=script&lang=js"
export * from "./producer_tastings_tab.vue?vue&type=script&lang=js"
import style0 from "./producer_tastings_tab.vue?vue&type=style&index=0&id=6e6842ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6842ad",
  null
  
)

export default component.exports